import React from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import useFieldWrapperLabel from "v4/components/form/FieldWrapper/hooks/useFieldWrapperLabel";
import Field from "v4/components/form/Field/Field";
import toKebabCase from "v4/utils/toKebabCase";
import {HIDDEN_TYPE} from "v4/data/fieldTypes";

export default function FieldWrapper({field, name, onChange, className = '', isLabelActive = false, children}) {
    const {t} = usePolTranslation();
    const {
        isLabelActive: isLabelActiveFromHook,
        fieldPrefix,
        fieldLabel,
        fieldType,
        fieldWrapperRef,
    } = useFieldWrapperLabel(field);

    if (!field) return null;

    const {addon, ...fieldWithoutAddon} = field;

    if (field.type === HIDDEN_TYPE) {
        return (
            <Field prefix={fieldPrefix} name={name} {...fieldWithoutAddon}/>
        )
    }

    const fieldElement = <Field prefix={fieldPrefix} onFieldChange={onChange} {...fieldWithoutAddon} name={name}/>;

    return (
        <div className={`input-field-wrapper ${toKebabCase(fieldType)} ${className}`} ref={fieldWrapperRef}>
            {children ? (
                typeof children === 'function'
                    ? children({fieldPrefix})
                    : children
            ) : addon ? (
                <div className="input-field-addon-wrapper">
                    {fieldElement}
                    <span className="input-field-addon">{addon}</span>
                </div>
            ) : (
                fieldElement
            )}
            {fieldLabel && (
                <label htmlFor={`${fieldPrefix}${name}`}
                       className={(isLabelActive || isLabelActiveFromHook) ? 'active' : ''}>
                    {t(fieldLabel)}
                </label>
            )}
        </div>
    )
}

